<template>
  <div>
    <nav-bar/>
    <div class="container">
      <div class="row mt-3">
        <div class="col-12">
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              class=" mb-1"
              flat
              label="جستجو"
              single-line
              solo
          background-color="greyColor"></v-text-field>
          <v-data-table
              :headers="headers"
              :items="list"
              :items-per-page="5"
              :mobile-breakpoint="680"
              :search="search"
              :loading="loading"
              loading-text="درحال بارگذاری... لطفا صبر کنید"
              class="data-table"
              fixed-header
              disable-sort
              show-expand
              :expanded.sync="expanded"
              :single-expand="singleExpand"
              item-key="DeliveryAddressID">
            <template v-slot:[`item.count`]="{ index}">
              <div>{{ index + 1 }}</div>
            </template>

            <template v-slot:[`expanded-item`]="{ item }">
              <td>
                <div>
                  <div v-html="item.Address"></div>
                </div>
              </td>
            </template>
            <template v-slot:[`item.IsActive`]="{ item }">
              <div v-if="item.IsActive">بله</div>
              <div v-else>خیر</div>
            </template>
            <!--          <template v-slot:[`item.NewsCategoryId`]="{  }">-->
            <!--            <div>{{ categoryName }}</div>-->
            <!--          </template>-->
            <template v-slot:[`item.IsVip`]="{ item }">
              <div v-if="item.IsVip">بله</div>
              <div v-else>خیر</div>
            </template>


            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                  class="edit-User"
                  icon
                  dark
                  color="primary"
                  @click="editAddress(item.DeliveryAddressID)"
              >
                <i class="fas fa-edit ml-1 "></i>
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
      <FooterComponent/>
    </div>
</template>

<script>
import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";

export default {
  name: "listAddress",
  components: {FooterComponent, NavBar},
  metaInfo () {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  mounted() {
    this.getData()
  },
  data: () => ({
    loading: true,
    src: 'logo.png',
    showLoaderDialog: false,
    search: null,
    listCategories: [],
    expanded: [],
    singleExpand: true,
    categoryName: null,
    headers: [
      {text: 'ردیف', value: 'count'},
      {text: 'نام', value: 'fullName'},
      {text: 'موبایل', value: 'MobilePhone'},
      {text: 'آدرس', value: 'data-table-expand'},
      {text: '', value: 'actions'},
    ],
    list: [],
  }),
  methods: {
    getData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/DefineDeliveryList", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.list = json
            console.log(json)
            this.loading = false
            for (let i = 0; i < json.length; i++) {
              json[i].fullName = json[i].Name + " " + json[i].Family;
            }

          })
          .catch(error => console.log('error', error));
    },
    editAddress(id) {
      this.$router.push({path: 'manageAddress', query: {id: id, isNew: false}})

    }
  }
}
</script>

<style scoped>

</style>